<!--adding in logic to show filter/pagination -->
<!-- TODO: Might make sense to make this button its own component -->
<div class="table-controls" *ngIf="showFilter || showExport">
  <mat-form-field
    *ngIf="showFilter"
    subscriptSizing="dynamic"
    class="filter-box"
  >
    <input
      matInput
      #tableFilter
      (keyup)="applyFilter($event.target.value)"
      placeholder="{{ this.filterLabel }}"
      [(ngModel)]="filterString"
    />
    <!--  original ngif checked filterString, adding truthy to show if it has any value-->
    <button
      *ngIf="!!filterString"
      mat-button
      class="search-button"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="clearFilter()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <wfdss-export-button
    *ngIf="showExport"
    class="table-export-button"
    role="button"
    [attr.aria-label] = "showExport"
    tabindex="1"
    style="cursor: pointer;"
    (click)="export()"
    matTooltip="Click to Download"
  >
  </wfdss-export-button>
</div>

<!-- </div> -->

<div class="wrapper-class">
  <caption id="tableTitle">
    {{
      title
    }}
  </caption>
  <table
    mat-table
    class="app-table"
    [dataSource]="dataSource"
    style="width: 100%"
    [fixedLayout]="fixedLayout"
    matSort
    [matSortActive]="sortActive"
    [matSortDirection]="sortDirection"
    [matSortDisableClear]="true"
    aria-describedby="tableTitle"
  >
    <ng-container *ngFor="let columnObj of columnMetaInformation">
      <ng-container matColumnDef="{{ columnObj.columnName }}">
        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">
          {{ columnObj.columnName }}
        </th>
        <td mat-cell tabindex="0"
            *matCellDef="let row"
            style="margin: 0px; padding: 0px"
            [ngClass]="columnObj.columnAlignment === 'right' ? 'right-align' : columnObj.cellClassName ? (row | accessorPipe : columnObj.cellClassName) : ''"
            >
            <div *ngIf="columnObj.checkbox">
            </div>
            <div *ngIf="columnObj.cellClick; else displayCell">
              <div *ngIf="columnObj.cellClick.checkbox else isButton" wfdss-click-stop-propagation>
                <mat-checkbox wfdss-click-stop-propagation (change)="columnObj.cellClick.onCellClick(row)" 
                 color="primary">{{columnObj.cellClick.checkbox.checkboxText}}
              </mat-checkbox>
                <!-- <mat-checkbox wfdss-click-stop-propagation (change)="columnObj.cellClick.onCellClick(row)" 
                [(ngModel)]="columnObj.cellClick.checkbox.checked['{{row.title}}']" color="primary">{{columnObj.cellClick.checkbox.checkboxText}}
              {{columnObj.cellClick.checkbox.checked['{{row.title}}']}}
              </mat-checkbox> -->

            </div>
              <ng-template #isButton>
              <button 
                *ngIf="columnObj.cellClick.icon"
                mat-icon-button
                color = "{{columnObj.cellClick.iconColor}}"
                aria-label="{{columnObj.cellClick.iconAriaLabel}}"
                style="font-size: .75rem; padding: 0px;" [disabled]=columnObj.cellClick.isDisabled(row)
                wfdss-click-stop-propagation
                (click)="columnObj.cellClick.onCellClick(row)">
                  <mat-icon>{{columnObj.cellClick.icon}}</mat-icon>
              </button>
              <button 
                *ngIf="!columnObj.cellClick.icon"
                mat-button
                [disabled] = "columnObj.cellClick.isDisabled(row)"
                class="primary-button" style="font-size: .75rem; padding: 0px;" [disabled]=columnObj.cellClick.disabled
                wfdss-click-stop-propagation
                (click)="columnObj.cellClick.onCellClick(row)">
                  {{columnObj.cellClick.buttonLabel}}
              </button>
              </ng-template>
          </div>
          <ng-template #displayCell>
            <ng-container *ngIf="!columnObj.isHTML">
              {{ row | accessorPipe : columnObj.propertyAccessor }}
            </ng-container>            
            <ng-container *ngIf="columnObj.isHTML">
              <span [innerHTML]="row | accessorPipe : columnObj.propertyAccessor">Test</span>
            </ng-container>
          </ng-template>
        </td>
          <!-- <td > THEERES A THING</td> -->

        <!-- <ng-template #standard>
          <td mat-cell *matCellDef="let foo">{{ foo | accessorPipe : columnObj.propertyAccessor }}</td>
        </ng-template> -->
        <!-- <td
          (click) = "columnObj.cellClick('test str')"
          mat-cell
          *matCellDef="let foo"
        >
          {{ foo | accessorPipe : columnObj.propertyAccessor }}
        </td> -->
      </ng-container>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="cols"></tr>
    <tr tabindex="0"
      mat-row
      *matRowDef="let row; columns: cols"
      (click)="onClicked(row)" (keydown.enter)="onClicked(row)"
      [ngClass]="displayPointerOnHover ? 'cursor-and-bg' : ''"
      [class.disabled-row]="row.disabled"

    ></tr>
  </table>
  <ng-content></ng-content>

  <mat-paginator
    [pageSizeOptions]="[10, 20, 50, 100, 200]"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    showFirstLastButtons
  ></mat-paginator>
</div>
